import React, { useState, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import Markdown from "react-markdown";
import axios from "axios";
import classNames from "classnames";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@mantine/core";
import { Busy } from "./UIComponents";
import { UserManagerContext } from "../Context/userManagerContext";
import { handleError } from "../AppCommon/util";
import { STATE_CULTURE } from "../Actions/stateActions";

let source;

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "1rem",
    paddingBottom: "32px",
    color: theme.app.secondaryColor,
  },
  buttonWrapper: {
    display: "flex",
    gap: "1rem",
  },
}));

const Default = (props) => {
  const { isAuth } = props;
  const classes = useStyles();
  const [busy, setBusy] = useState(false);
  const [text, setText] = useState("");
  const { userManager } = useContext(UserManagerContext);

  const { config, culture, language } = useSelector((state) => ({
    config: state.config,
    culture: state.cookies[STATE_CULTURE],
    language: state.language,
  }));

  const registerLink = `${config?.auth.split("auth")[0]}members/registermember`;

  useEffect(() => {
    let CancelToken = axios.CancelToken;
    source = CancelToken.source();
    axios
      .get(`/ee-static/booking/Texts/default.${culture}.md`, {
        cancelToken: source.token,
      })
      .then((response) => {
        setText(response.data);
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
        }
      });
    return () => source.cancel("Component Is Unmounting");
  }, [culture]);

  useEffect(() => {
    const handleLogin = () => {
      userManager.clearStaleState();
      userManager.signinRedirect().catch(handleError);
    };
    if (busy) {
      handleLogin();
    }
  }, [busy, userManager]);
  if (isAuth) return <div />;
  if (busy) return <Busy text="Väntar på inloggning" />;

  return (
    <div className={classNames(classes.container, "default__container")}>
      <Markdown
        source={text}
        escapeHtml={false}
        skipHtml={false}
        className="default-text-container"
      />
      <div className={classes.buttonWrapper}>
        <Button
          className="primaryButton"
          component="a"
          href={registerLink}
          aria-label={language.register}
          variant=""
          color="violet.9"
        >
          {language.register || "Registrera"}
        </Button>
        <Button
          className="primaryButton"
          onClick={() => setBusy(true)}
          aria-label={language.login}
          variant=""
          color="violet.9"
        >
          {language.login || "Login"}
        </Button>
      </div>
    </div>
  );
};

export default Default;
